import React from "react";
import FaqPage from "../../components/Main/Faq";

function Faq() {
  return <FaqPage />;
}

export default Faq;
